import { Injectable } from '@angular/core';
import { Http, Headers, URLSearchParams, Response, HttpModule, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TripService {

  base_url: string;
  constructor(
    public http: HttpClient,
  ) {
    this.base_url = environment.appUrl + "/trips";
  }

  getAllTrips(): Observable<any> {
    return this.http.get(this.base_url);
  }

  getAllTripsByTypesDateRange(tripTypes, page: number, from: Date, to: Date, selectedZone: string): Observable<any> {
    return this.http.get(this.base_url + '/typedaterange' + '?page=' + page + '&type=' + tripTypes + '&fromDate=' + from + '&toDate=' + to + '&branches=' + JSON.parse(window.sessionStorage.getItem("userBranchNames")) + '&zone=' + selectedZone);
  }

  getTripById(tripId): Observable<any> {
    return this.http.get(this.base_url + "/" + tripId);
  }

  getOrdersTripById(tripId): Observable<any> {
    return this.http.get(this.base_url + "/id/" + tripId + "/orders");
  }

  createTrip(orderArray: Array<any>): Observable<any> {
    return this.http.post(this.base_url, orderArray);
  }

  assignFleetToTrip(tripId, fleetId): Observable<any> {
    return this.http.put(this.base_url + "/" + tripId + "/assignfleet?fleetId="+fleetId,null);
  }

  assignDriverToTrip(tripId, resourceId): Observable<any> {
    return this.http.put(this.base_url + "/" + tripId + "/assigndriver?resourceId=" + resourceId, null);
  }

  scheduleTrip(tripId): Observable<any> {
    return this.http.put(this.base_url + "/" + tripId + "/" + "schedule", null);
  }

  deleteTrip(tripId): Observable<any> {
    return this.http.delete(this.base_url + "/id/" + tripId);
  }

  getTripCountByStatus(from, to): Observable<any> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.http.get(this.base_url + '/status/count/branch?fromDate=' + from + '&toDate=' + to)
  }

  deleteOrderFromTrip(orderId, tripId): Observable<any> {
    return this.http.delete(this.base_url + "/id/" + tripId + "/orders/" + orderId);
  }

  togglePostSN(): Observable<any> {
    return this.http.put(this.base_url + "/" + "togglepostsn", null);
  }

  getTripReport(from, to): Observable<any> {
    return this.http.get(environment.appUrl + '/reports/tripSummary?fromDate=' + from + '&toDate=' + to);
  }

  getsummaryReport(from, to): Observable<any> {
    return this.http.get(environment.appUrl + '/reports/usersummarydaterange?fromDate=' + from + '&toDate=' + to);
  }

  assignHelperToTrip(tripId, resourceId): Observable<any> {
    return this.http.put(this.base_url + "/" + tripId + "/assignhelper?resourceId=" + resourceId,null);
  }

  getFormattedTime(timeInMiliSecond) {
    let totalHours, totalMinutes, totalSeconds, hours, minutes, result = '';
    totalSeconds = timeInMiliSecond / 1000;
    totalMinutes = totalSeconds / 60;
    totalHours = totalMinutes / 60;

    minutes = Math.floor(totalMinutes) % 60;
    hours = Math.floor(totalHours) % 60;

    if (hours !== 0) {

      if (hours.toString().length == 1) {
        hours = '0' + hours;
      }
      result += hours + ' Hours ';

      if (minutes.toString().length == 1) {
        minutes = '0' + minutes;
      }
    }

    result += minutes + ' Minutes';

    return result;
  }
  getTripSummaryReport(from, to): Observable<any> {
    return this.http.get(environment.appUrl + '/reports/tripstatsbybranch?fromDate=' + from + '&toDate=' + to);
  }

  trackOrder(trackId) {
    return this.http.get(environment.appUrl + '/trackorder/id/' + trackId);
  }
}
